import React from 'react'
import Employers from '../fetures/employers/Employers'

const EmployersPage = () => {
  return (
    <Employers/>
  )
}

export default EmployersPage